import axios, { AxiosResponse } from 'axios';
import { IDocumentRequest } from '../model/search.model';
import { IDocument } from '../model/document.model';

export interface IDocumentApi {
  uploadDocuments(doucment: IDocument[]): Promise<AxiosResponse<any>>;
}

export class DocumentApi implements IDocumentApi {
  uploadDocuments(doucment: IDocument[]): Promise<AxiosResponse<any>> {
    return axios.post('api/document/uploadDocuments', doucment);
  }
}
